import { useEffect, useState } from "react";
import "@/App.css";
import axios from "axios";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import ContentContext from "@/context/ContentContext";
import { DEFAULT_CONTENT } from "@/constants/site";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Storia from "@/components/site/Storia";
import Galleria from "@/components/site/Galleria";
import OrariContatti from "@/components/site/OrariContatti";
import Preventivi from "@/components/site/Preventivi";
import Footer from "@/components/site/Footer";
import Admin from "@/pages/Admin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const scrollToSection = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Storia />
        <Galleria />
        <OrariContatti />
        <Preventivi />
      </main>
      <Footer />
    </>
  );
}

function App() {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    axios
      .get(`${API}/content`)
      .then((r) => setContent(r.data))
      .catch(() => {});
  }, []);

  return (
    <ContentContext.Provider value={content}>
      <div className="bg-sand-50 text-stone-900 font-sans">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" toastOptions={{ style: { borderRadius: 0 } }} />
      </div>
    </ContentContext.Provider>
  );
}

export default App;
